module.exports = __webpack_public_path__ + "img/gearbox-poster-banner1.20272728.jpg";